import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['play', 'background', 'foreground']

  state = {
    src: this.data.get('src') || false,
    loaded: false,
    loadedClass: 'is-loaded'
  }

  connect() {
  }

  load(event) {
    const {
      state
    } = this;
    if (!state.loaded && state.src) {
      const iframe = this.iframe(state.src);
      this.backgroundTarget.innerHTML = iframe;
      this.element.classList.add(state.loadedClass);
      state.loaded = true;
    }
  }

  iframe(src) {
    return `<iframe src="${src}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  }
}
